import React from "react";
import { cn } from "@/lib/utils";

interface OutlinedDivProps {
  label: string;
  children: React.ReactNode;
  disabled?: boolean;
  padding?: string | number;
}

const OutlinedDiv: React.FC<OutlinedDivProps> = ({
  label,
  children,
  disabled = false,
  padding,
}) => {
  return (
    <fieldset
      className={cn(
        "border rounded-md px-3 pb-3 flex-grow w-full h-full min-w-0",
        disabled && "opacity-50 pointer-events-none",
      )}
      style={padding ? { padding } : undefined}
    >
      {label && (
        <legend
          className={cn(
            "text-sm font-medium px-1",
            disabled ? "text-muted-foreground" : "text-foreground",
          )}
        >
          {label}
        </legend>
      )}
      {children}
    </fieldset>
  );
};

export default OutlinedDiv;
